<div class="tree-node"
     [class.is-root]="node().data?.['isRoot']"
     [class.is-leaf]="node().data?.['isLeaf']"
     [class.is-internal]="!node().data?.['isLeaf'] && !node().data?.['isRoot']"
     ngDiagramNodeSelected
     [node]="node()"
     [attr.data-node-id]="node().id">
  <span>{{ node().data?.['label'] }}</span>
  <ng-diagram-port id="port-top" type="target" side="top" />
  <ng-diagram-port id="port-bottom" type="source" side="bottom" />
</div>
